export const VERSION_CONFIG = {
  admin: {
    appVersion: "v1.3.0",
    buildNumber: "build.20261029.04"
  },
  superAdmin: {
    appVersion: "v1.0.0",
    buildNumber: "build.20261028.04"
  }
};
